import { render, staticRenderFns } from "./historical_data.vue?vue&type=template&id=633e5a8e&scoped=true&"
import script from "./historical_data.vue?vue&type=script&lang=js&"
export * from "./historical_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633e5a8e",
  null
  
)

export default component.exports